export const PASSWORD_MIN_LENGTH = 8

/**
 * Password policy shown to the user and enforced before submit. It mirrors the IAM backend
 * (`^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s]).{8,}$`) rule for rule, so a password
 * that passes here is never rejected by the API for policy reasons.
 */
export const PASSWORD_RULES = [
  { key: 'minLength', isMet: (value: string) => value.length >= PASSWORD_MIN_LENGTH },
  { key: 'lowercase', isMet: (value: string) => /[a-z]/.test(value) },
  { key: 'uppercase', isMet: (value: string) => /[A-Z]/.test(value) },
  { key: 'digit', isMet: (value: string) => /\d/.test(value) },
  { key: 'special', isMet: (value: string) => /[^a-z\d\s]/i.test(value) },
] as const

export type PasswordRuleKey = (typeof PASSWORD_RULES)[number]['key']
